import { combineReducers } from 'redux';
import { all, fork } from 'redux-saga/effects';
import { documentTemplateRootSaga } from './documents/sagas';
import { documentTemplateSlice } from './documents/slices';
import { projectTemplateRootSaga } from './projects/sagas';
import { projectTemplateSlice } from './projects/slices';
import { watchAllTemplateChangesSaga } from './sagas/track-all';
import { templateSlice } from './slices';
import { variableTemplateRootSaga } from './variables';

const templateReducer = templateSlice.reducer;
const projectTemplateReducer = projectTemplateSlice.reducer;
const documentTemplateReducer = documentTemplateSlice.reducer;

export const templatesReducer = combineReducers({
  dirty: templateReducer,
  project: projectTemplateReducer,
  document: documentTemplateReducer,
});

export const templatesRootSaga = function* () {
  yield all([
    fork(projectTemplateRootSaga),
    fork(documentTemplateRootSaga),
    fork(variableTemplateRootSaga),
    fork(watchAllTemplateChangesSaga),
  ]);
};

export const { setDirtyState } = templateSlice.actions;
